import { Injectable } from '@angular/core';
import { RestService } from '../../../core/service/rest.service';
import { MaterialDetailsAPIConstant } from '../constant/material-details.constant';

@Injectable({
  providedIn: 'root'
})
export class MaterialDetailsService {

  constructor(private rest:RestService) { }

  getIntergrationLogDetails(payload: any,requestId:any) { return this.rest.get(MaterialDetailsAPIConstant.getIntergrationLogDetails+`?requestId=${requestId}`, payload)}
  getPreviousVersionDetails(payload: any,requestId:any){ return this.rest.get(MaterialDetailsAPIConstant.getProductVariantById+`?requestId=${requestId}`, payload)}
  getDataWithComparison(currentRequestId:any,previousRequestId:any,materialType:any){ return this.rest.get(MaterialDetailsAPIConstant.getDataWithComparison+`?currentRequestId=${currentRequestId}&previousRequestId=${previousRequestId}&materialType=${materialType}`)}
}
